import model from './model';
import image from './image';
import camera from './camera';

import { getField, updateField } from 'vuex-map-fields';
import DetectionService from '@/services/detection.service';

const SET_STATE = 'SET_STATE';
const SET_AUTO_SLIDE = "SET_AUTO_SLIDE";


export default {
	namespaced: true,
	state: {
		state: false,
		isModalVisible: false,
    autoSlide: false,
	},

	actions: {
		/**
		 * start detection server
		 * @param {*} param0
		 * @param {Object} payload
		 * @returns
		 */
		async loadModel({ commit }, payload) {
			let response = await DetectionService.unloadModel({
				user: payload.username,
			});

			if (response.status != 200) return;

			response = await DetectionService.loadModel({
				user: payload.username,
				model_name: payload.model,
				threshold: payload.threshold,
			});
			if (response.status != 200) return;

			commit(SET_STATE, true);
		},

		/**
		 * stop detection server
		 * @param {*} param0
		 * @param {*} payload
		 */
		async unloadModel({ commit }, payload) {
			await DetectionService.unloadModel({
				user: payload.username,
			});

			commit(SET_STATE, false);
		},

		showFormModal({ commit }) {
			commit('showModal');
		},
		hideFormModal({ commit }) {
			commit('hideModal');
		},

		
    switchAutoSlide({ commit, state }) {
      commit(SET_AUTO_SLIDE, !state.autoSlide);
    }
	
	},
	mutations: {
		updateField,

		SET_STATE(state, payload) {
			state.state = payload;
		},

		showModal(state) {
			state.isModalVisible = true;
		},
		hideModal(state) {
			state.isModalVisible = false;
		},
		
    SET_AUTO_SLIDE(state, payload) {
      state.autoSlide = payload;
    }
	
	},
	getters: {
		getField,
	},
	modules: {
		model,
		image,
		camera,
	},
};
